import { makeAutoObservable } from 'mobx'
import { api } from 'index'
import { jwtDecode } from 'jwt-decode'

const DEFAULT_DATA = () => ({
  id: '',
  image: '',
  name: '',
  email: '',
})

class _UserStore {
  constructor() {
    this.data = DEFAULT_DATA()
    makeAutoObservable(this, {}, { autoBind: true })
  }

  async getUserData() {
    try {
      const { data, errors } = await api.user.get()

      if (errors?.length) {
        throw new Error(errors.toString())
      }

      this.SET_DATA(data)
    } catch (e) {
      console.error(e.message)

      this.clearUserData()
    }
  }

  SET_DATA(data) {
    this.data = data
  }

  updateUserData() {
    const token = localStorage.getItem('token')
    if (!token) return

    const data = jwtDecode(token)

    const _data = Object.keys(data).reduce((acc, key) => {
      if (typeof this.data[key] !== 'undefined') {
        acc[key] = data[key]
      }
      return acc
    }, {})

    this.data = { ...this.data, ..._data }
  }

  clearUserData() {
    this.data = DEFAULT_DATA()
  }
}
const UserStore = new _UserStore()

export { UserStore }
